/**
 * Feature flags de la aplicación.
 *
 * Interruptores para funcionalidad que existe en el código pero no debe estar
 * accesible todavía. Se prefiere apagar aquí en lugar de borrar código: el día
 * que la funcionalidad se retome, basta con cambiar el valor.
 */

/**
 * Pagos y planes de suscripción (Stripe).
 *
 * Apagado a propósito: la integración no está configurada en ningún entorno
 * —los secretos de Stripe no se montan en Cloud Run y en prod ni siquiera
 * tienen versión— así que el flujo de checkout no puede completarse. Mientras
 * esté en false se oculta el acceso en el menú y la ruta /recruiter/checkout
 * no es alcanzable.
 *
 * Para reactivarlo: poner en true, montar STRIPE_SECRET_KEY y
 * STRIPE_WEBHOOK_SECRET en el despliegue, y definir VITE_STRIPE_PUBLISHABLE_KEY.
 */
export const PAYMENTS_ENABLED = false;

/**
 * Qué proveedores de identidad se ofrecen en el login de esta instancia.
 *
 * Se decide por entorno, en el despliegue: people entra sólo con Google e
 * inndot sólo con Microsoft. Enseñar un botón que el tenant del cliente no
 * puede usar sólo genera intentos fallidos y desconfianza.
 *
 * Es UNA lista y no dos interruptores independientes a propósito: dos booleanos
 * admiten el estado "los dos apagados", que deja la plataforma sin forma de
 * entrar. Con una lista, vacío significa "lo de siempre" en vez de "nada".
 *
 * Valor: `VITE_AUTH_PROVIDERS`, separados por ';'  —  "google", "microsoft",
 * o "google;microsoft" si alguna instancia necesitara las dos.
 */
export type ProveedorAuth = 'google' | 'microsoft';

const PROVEEDORES_VALIDOS: ProveedorAuth[] = ['google', 'microsoft'];

function leerProveedores(): ProveedorAuth[] {
  const crudo = (import.meta.env.VITE_AUTH_PROVIDERS ?? '') as string;
  const pedidos = crudo
    .split(';')
    .map((p) => p.trim().toLowerCase())
    .filter((p): p is ProveedorAuth => (PROVEEDORES_VALIDOS as string[]).includes(p));

  // Sin configuración válida se cae a Google, que es lo que han usado todos los
  // entornos hasta ahora. Quedarse sin ningún botón sería peor que ofrecer el
  // que probablemente toca.
  return pedidos.length > 0 ? Array.from(new Set(pedidos)) : ['google'];
}

export const AUTH_PROVIDERS: ProveedorAuth[] = leerProveedores();

export const GOOGLE_LOGIN_ENABLED = AUTH_PROVIDERS.includes('google');
export const MICROSOFT_LOGIN_ENABLED = AUTH_PROVIDERS.includes('microsoft');
